@if (viewType === ViewType.UpgradePlan) {
  <div class="grow-header">
    <rt-badge color="default" [text]="'app.pricing.grow' | translate" /><rt-heading
      variant="heading large"
      >{{ 'app.pricing.feature_guard.available_in_grow' | translate }}</rt-heading
    >
  </div>
}
<rt-dialog-body
  [class.radius-bottom]="viewType === ViewType.UpgradePlan"
  variant="white no-padding"
  layout
  layout-justify-center
>
  <img src="assets/images/pricing/offer-slots-limit/offer-slots-limit.svg" alt="" />
  <rt-heading variant="heading large-xx">
    <span [innerHTML]="heading"></span>
  </rt-heading>
  <p margin-bottom-small text-center>
    {{ description }}
  </p>

  @switch (viewType) {
    @case (ViewType.GetInTouch) {
      <rt-button (click)="openIntercom()" variant="primary">
        {{ 'app.pricing.slots_limit.description.get_in_touch' | translate }}
      </rt-button>
    }
    @case (ViewType.UpgradePlan) {
      <rt-plan-button
        class="default"
        [hasIcon]="false"
        (click)="openPlanPickerDialog()"
        variant="grow"
      >
        {{ 'app.pricing.feature_guard.upgrade_plan' | translate }}
      </rt-plan-button>
    }
    @case (ViewType.Upgrade) {
      <rt-button (click)="openPlanPickerDialog()" variant="primary">
        {{
          (isTrial
            ? 'app.pricing.slots_limit.description.choose_plan'
            : 'app.pricing.slots_limit.description.upgrade_now'
          ) | translate
        }}
      </rt-button>
    }
    @case (ViewType.AdminsAvatars) {
      <rt-admins-avatars [admins]="teamMembers" [editable]="false" [stacked]="true" [limit]="4" />
    }
  }

  @if (showSaveAsDraft) {
    <a (click)="saveAsDraft()" margin-top-small class="link">
      {{
        (isTrial
          ? 'app.pricing.slots_limit.description.save_as_draft_trial'
          : 'app.pricing.slots_limit.description.save_as_draft'
        ) | translate
      }}
    </a>
  }
</rt-dialog-body>
